import { createRouter, createWebHistory } from 'vue-router'
import DefaultLayout from '@/layouts/DefaultLayout.vue'
import Home from '@/pages/Home.vue'
import ProblemList from '@/pages/ProblemList.vue'
import SubmissionList from '@/pages/SubmissionList.vue'
import ACCESS_ENUM from '@/access/accessEnum'

const routes = [
  {
    path: '/user/login',
    name: '登录',
    component: () => import('@/pages/Login.vue'),
    meta: {
      hideInMenu: true
    }
  },
  {
    path: '/noAuth',
    name: '无权限',
    component: () => import('@/pages/NoAuth.vue'),
    meta: {
      hideInMenu: true
    }
  },
  {
    path: '/user/register',
    name: '注册',
    component: () => import('@/pages/Register.vue'),
    meta: {
      hideInMenu: true
    }
  },
  {
    path: '/',
    component: DefaultLayout,
    children: [
      {
        path: '',
        name: '首页',
        component: Home,
        meta: { title: '首页' }
      },
      {
        path: 'problems',
        name: '题目',
        component: ProblemList,
        meta: { title: '题目' }
      },
      {
        path: 'submissions',
        name: '提交记录',
        component: SubmissionList,
        meta: { title: '提交记录' }
      },
      {
        path: 'problem/create',
        name: 'Create Problem',
        component: () => import('@/pages/CreateProblem.vue'),
        meta: { title: '创建题目', hideInMenu: true, access: ACCESS_ENUM.ADMIN }
      },
      {
        path: 'manage/problems',
        name: '管理题目',
        component: () => import('@/pages/ManageProblems.vue'),
        meta: { title: '管理题目', access: ACCESS_ENUM.ADMIN }
      },
      {
        path: 'problem/edit/:id',
        name: 'Edit Problem',
        component: () => import('@/pages/CreateProblem.vue'),
        meta: { title: '编辑题目', hideInMenu: true, access: ACCESS_ENUM.ADMIN }
      },
      {
        path: 'problem/:id',
        name: 'Problem Detail',
        component: () => import('@/pages/ProblemView.vue'),
        meta: { title: '题目详情', hideInMenu: true }
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router